// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"2cdf6809","823":"2cdf6809"}[chunkId] + ".chunk.css";
};